import { createFeatureSelector, createSelector } from '@ngrx/store';
import { NotesState } from './notes.reducer';

export const getNotePageState = createFeatureSelector<NotesState>('notes');

export const getNotesModalState = createSelector(
  getNotePageState,
  (state: NotesState) => state?.isNoteModalOpened,
);
